module.exports = __webpack_public_path__ + "assets/img/driver-btn-98a20311.png";